import { toast } from "react-toastify";
import {
  onAddAppQuestion,
  onAddAppraisalTemp,
  onGetOrgAppTemplates,
  onGetOrgAppTempQuests,
  onUpdateAppTempinfo,
  onUpdateQuestion,
} from "../services/appraisal";
import { useStateGetter } from "./statehooks/UseStateGettersHook";
import { useEffect, useState } from "react";
import { useStateSetter } from "./statehooks/UseStateSettersHook";

export default () => {
  const { config } = useStateGetter();
  const [orgAppTemplates, setorgAppTemplates] = useState([]);
  const { setLoading } = useStateSetter();
  const { SelectedOrg } = useStateGetter();

  const defaultTemplate = [
    {
      metadata: {
        name: "Employee Feedback Template",
        //   "deptID": 12, // Optional
        role: "Manager",
        approval: "No Approval",
        desc: "Collect feedback directly from employees to drive growth.",
        organizationID: SelectedOrg.id,
      },
      questions: [
        {
          question: "What are your key achievements in this review period?",
          responseType: "text",
          tempID: 1,
          organizationID: SelectedOrg.id,
        },
        {
          question: "Which areas do you feel you could improve upon?",
          responseType: "text",
          tempID: 1,
          organizationID: SelectedOrg.id,
        },
        {
          question: "Do you feel your current role leverages your strengths?",
          responseType: "options",
          options: ["Yes", "No", "Partially"],
          tempID: 1,
          organizationID: SelectedOrg.id,
        },
        {
          question: "How would you rate your overall performance?",
          responseType: "ratings",
          options: ["Yes", "No", "Partially"],
          tempID: 1,
          organizationID: SelectedOrg.id,
        },
      ],
    },
    {
      metadata: {
        name: "Manager Feedback Template",
        //   "deptID": 12, // Optional
        role: "Manager",
        approval: "No Approval",
        desc: "Gain feedback from managers to support employee growth.",
        organizationID: SelectedOrg.id,
      },
      questions: [
        {
          question:
            "How well does the employee meet their job responsibilities?",
          responseType: "ratings",
          tempID: 1,
          organizationID: SelectedOrg.id,
        },
        {
          question: "What specific areas has the employee excelled in?",
          responseType: "text",
          tempID: 1,
          organizationID: SelectedOrg.id,
        },
        {
          question: "Does the employee exhibit collaboration and teamwork?",
          responseType: "options",
          options: ["Always", "Sometimes", "Rerely", "Never"],
          tempID: 1,
          organizationID: SelectedOrg.id,
        },
        {
          question:
            "How likely are you to recommend this employee for advanced responsibilities?",
          responseType: "ratings",
          options: ["Likely", "Very Likely", "Unlikely", "Very Unlikely"],
          tempID: 1,
          organizationID: SelectedOrg.id,
        },
      ],
    },
  ];

  const getTempQuestions = async (id: number) => {
    var res = await onGetOrgAppTempQuests(id, config);

    return res.data;
  };
  const updateQuestion = async (id: number, postdata: any) => {
    setLoading(true);
    try {
      let response = await onUpdateQuestion(id, postdata, config);
    } catch (e: any) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };
  const updateAppTempinfo = async (id: number, postdata: any) => {
    setLoading(true);
    try {
      let response = await onUpdateAppTempinfo(id, postdata, config);
    } catch (e: any) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const AddQuestdefTemplates = async () => {
    await Promise.all(
      orgAppTemplates.map(async (lk: any) => {
        var quest = await getTempQuestions(lk.id);
        if (lk.name == "Employee Feedback" && quest.length == 0) {
          try {
            defaultTemplate[0].questions.map(async (ll: any) => {
              var rex = await AddTempQuestions({ ...ll, tempID: lk.id });
            });
          } catch (e) {
            console.log(e);
          } finally {
          }
        } else if (lk.name == "Manager Feedback" && quest.length == 0) {
          try {
            defaultTemplate[1].questions.map(async (ll: any) => {
              var rex = await AddTempQuestions({ ...ll, tempID: lk.id });
            });
          } catch (e) {
            console.log(e);
          } finally {
          }
        }
      })
    );
  };

  const getOrgTemplates = async () => {

    setLoading(true);
    try {
      var orgtemplateRes = await onGetOrgAppTemplates(SelectedOrg.id, config);
      setorgAppTemplates(orgtemplateRes.data);
      if (orgtemplateRes.data.length == 0) {
        toast("no temp");
        //  await  createOrgDefTemplates();
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };


  const AddAppTemp = async (postdata: any) => {
    var response = await onAddAppraisalTemp(postdata, config);
    return response;
  };

  const AddTempQuestions = async (postdata: any) => {
    var response = await onAddAppQuestion(postdata, config);
    return response;
  };

  useEffect(() => {
    getOrgTemplates();
  }, []);
  useEffect(() => {
    AddQuestdefTemplates();
  }, [orgAppTemplates]);

  return { AddAppTemp, getTempQuestions,updateQuestion, updateAppTempinfo,AddTempQuestions, orgAppTemplates, getOrgTemplates };
};
